import React, { useCallback, useMemo, useState } from 'react';

import Button from 'react-bootstrap/Button';
import { useDispatch, useSelector } from 'react-redux';
import { CODEX } from "rbac/RbacContentProvider";

import CAT_CONSTANTS from 'lookup/CatConstants';
import { sendAuthenticatedAsyncRequest } from 'services/AsyncRequestService';
import { getErrorMessage } from 'services/UtilityService';
import { getLoggedInUser } from 'services/AuthService';
import PERMISSIONS from "rbac/Permissions.json";
import { saveWorkingDsgInfo } from 'views/Cat/DynamicSwitchGroupDetails/DynamicSwitchGroupDetails.actions';
import { showNotification } from 'services/NotificationService';
import { useLocation } from 'react-router-dom';

const LOCK_ACTIONS = {
  ACQUIRE: 'acquire',
  RELEASE: 'release'
};

const EditDynamicSwitchGroupDetails = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const {
    isWorkingDsgEditable,
    editableBy,
    workingDynamicSwitchGroupId,
  } = useSelector((state) => ({
    isWorkingDsgEditable: state.dynamicSwitchGroupDetails
      ? state.dynamicSwitchGroupDetails.isWorkingDsgEditable
      : null,
    editableBy: state.dynamicSwitchGroupDetails
      ? state.dynamicSwitchGroupDetails.editableBy
      : null,
    workingDynamicSwitchGroupId: state.dynamicSwitchGroupDetails?.dynamicSwitchGroup
      ? state.dynamicSwitchGroupDetails.dynamicSwitchGroup.dynamicSwitchGroupId
      : null,
  }));

  const codexStatus = useSelector((state) =>
    state.codexVersion ? state.codexVersion.codexVersionStatus : null
  );

  const [loading, setLoading] = useState(false);
  const loggedInUser = useMemo(() => getLoggedInUser(), []);

  const isLoggedInUserCATAdmin = useCallback(
    () =>
      loggedInUser.authorities.includes(
        PERMISSIONS.PERM_ADMIN_RELEASE_LOCK
      ),
    [loggedInUser]
  );

  const lock = useCallback(
    (action, dynamicSwitchGroupId) => {
      setLoading(true);
      const url =
        isLoggedInUserCATAdmin() && action === LOCK_ACTIONS.RELEASE
    ? `/cat/dynamic-switch-groups/${dynamicSwitchGroupId}/edit-lock-by-admin/release` 
    : `/cat/dynamic-switch-groups/${dynamicSwitchGroupId}/edit-lock/${action}`;

    sendAuthenticatedAsyncRequest(
        `${url}`,
        'PUT', 
      null,
      (r) => {
          setLoading(false);
          const { dynamicSwitchGroupId: dsgId, editableBy: editableByResponse } =
            r.data;
          dispatch(saveWorkingDsgInfo(dsgId, editableByResponse));
        showNotification({
          title: `Action Successful!`,
            message:
              action === LOCK_ACTIONS.ACQUIRE
            ? 'You can now work on this Dynamic Switch Group. No other person will be allowed to edit it untill you stop editing.' 
            : 'You have stopped editing the Dynamic Switch Group.',
          position: 'br',
            type: 'success',
        });
      },
      (r) => {
          setLoading(false);
          showNotification(
            {
          title: 'Something went wrong!',
              message:
                getErrorMessage(r.data) ||
                `Unable to ${
                  action === LOCK_ACTIONS.ACQUIRE ? 'edit' : 'stop editing'
                } the Dynamic Switch Group.`,
          position: 'br',
              type: 'error',
      },
            'error'
    );
  }
      );
    },
    [isLoggedInUserCATAdmin, dispatch]
  );

    const queryParams = new URLSearchParams(location.search);
    const allowEditing = queryParams.get('showDisplayCodexBar') ? false : true;

    return ( 
    <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
      {CODEX.renderComponentIfCanChangeDSG(
        codexStatus === CAT_CONSTANTS.codexStatuses.IN_DEVELOPMENT &&
          allowEditing
          ? isWorkingDsgEditable 
            ? (editableBy &&
                editableBy.userId === loggedInUser.uuid) ||
              loggedInUser.authorities.includes(
                PERMISSIONS.PERM_ADMIN_RELEASE_LOCK
              ) // owned by loggedInUser OR CAT Admin
              ? (
                <Button
                  variant="danger"
                  size="sm"
                  disabled={loading}
                  onClick={() => lock(LOCK_ACTIONS.RELEASE, workingDynamicSwitchGroupId)}
                >
                  {loading ? 'Requesting...' : 'Stop Editing'}
                </Button>
              )
              : (
                <div className="rm-xs-top-label">
                  Lock acquired by {editableBy.name}
                </div>
              )
            : (
              <Button
                variant="success"
                size="sm"
                className="btn-text-white"
                disabled={loading}
                onClick={() => lock(LOCK_ACTIONS.ACQUIRE, workingDynamicSwitchGroupId)}
              >
                {loading ? 'Requesting...' : 'Start Editing'}
              </Button>
            )
          : null
      )}
      </div>
    );
};

export default EditDynamicSwitchGroupDetails;
